(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wearilo-home"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('wearilo-home-motion')) {
  customElements.define('wearilo-home-motion', class extends HTMLElement {
    connectedCallback() {
      if (this.motionReady) return;
      this.motionReady = true;
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.runningReveals = new Set();
      this.pauseButton = this.querySelector('.wr-motion-toggle');
      this.toggleMotion = () => {
        const paused = this.dataset.paused !== 'true';
        this.dataset.paused = String(paused);
        this.pauseButton.setAttribute('aria-pressed', String(paused));
      };
      this.pauseButton?.addEventListener('click', this.toggleMotion);
      this.onMotionChange = () => {
        this.revealObserver?.disconnect();
        this.runningReveals.forEach(animation => animation.cancel());
        this.runningReveals.clear();
        if (this.motionQuery.matches || this.dataset.motion !== 'true' || window.Shopify?.designMode || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
        this.revealObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            this.revealObserver.unobserve(entry.target);
            const animation = entry.target.animate([
              { opacity: 0, translate: '0 18px' },
              { opacity: 1, translate: '0 0' }
            ], { duration: 550, easing: 'cubic-bezier(.2,.7,.3,1)' });
            this.runningReveals.add(animation);
            animation.finished.then(() => this.runningReveals.delete(animation)).catch(() => this.runningReveals.delete(animation));
          });
        }, { threshold: 0.1 });
        this.querySelectorAll('.wr-section-heading, .wr-collection-card, .wr-values-intro, .wr-value, .wr-manifesto h2, .wr-manifesto>p, .wr-manifesto>a').forEach(element => {
          if (element.getBoundingClientRect().top >= window.innerHeight) this.revealObserver.observe(element);
        });
      };
      this.motionQuery.addEventListener('change', this.onMotionChange);
      this.onMotionChange();
    }
    disconnectedCallback() {
      this.revealObserver?.disconnect();
      this.runningReveals?.forEach(animation => animation.cancel());
      this.pauseButton?.removeEventListener('click', this.toggleMotion);
      this.motionQuery?.removeEventListener('change', this.onMotionChange);
      this.motionReady = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wearilo-product-details"] && !Shopify.designMode) return;
  try {
    
function formatWeariloDescriptions(scope = document) {
  scope.querySelectorAll('[data-wearilo-description]:not([data-formatted])').forEach((root) => {
    const labels = JSON.parse(root.dataset.labels);
    const groups = new Map(['overview', 'features', 'care', 'size'].map(key => [key, []]));
    let current = 'overview';
    const lines = [];
    let inline = [];
    const flush = () => {
      if (!inline.some(node => node.textContent.trim() || node.nodeType === 1 && node.tagName === 'IMG')) { inline = []; return; }
      const p = document.createElement('p');
      inline.forEach(node => p.append(node));
      lines.push(p);
      inline = [];
    };
    const scan = (node) => {
      if (node.nodeType === 3) { inline.push(node.cloneNode(true)); return; }
      if (node.nodeType !== 1) return;
      const tag = node.tagName;
      if (tag === 'BR') { flush(); return; }
      if (tag === 'TABLE' || /^(H[1-6]|UL|OL|BLOCKQUOTE|FIGURE)$/.test(tag)) {
        flush(); lines.push(node.cloneNode(true)); return;
      }
      if (/^(DIV|SECTION|ARTICLE|P)$/.test(tag)) {
        flush(); Array.from(node.childNodes).forEach(scan); flush(); return;
      }
      inline.push(node.cloneNode(true));
    };
    Array.from(root.childNodes).forEach(scan);
    flush();
    lines.forEach(node => {
      const text = node.textContent.trim();
      if (node.tagName === 'TABLE') { groups.get('size').push(node); return; }
      const label = text.toLowerCase().replace(/[:.]+$/, '').trim();
      let next = null;
      if (/^(product features|features|product details|your everyday layer|details|material[s]?|fabric)$/.test(label)) next = 'features';
      if (/^(care|care instructions|washing instructions|product care)$/.test(label)) next = 'care';
      if (/^(size guide|sizing|size chart|measurements)$/.test(label)) next = 'size';
      if (next) { current = next; return; }
      if (/^H[1-6]$/.test(node.tagName)) {
        if (current === 'overview') current = 'features';
        const heading = document.createElement('h4');
        heading.textContent = text;
        groups.get(current).push(heading);
        return;
      }
      if (/^[-•]\s*/.test(text) && node.tagName === 'P') {
        const items = groups.get(current);
        let list = items[items.length - 1];
        if (!list || list.tagName !== 'UL') { list = document.createElement('ul'); items.push(list); }
        const li = document.createElement('li');
        li.textContent = text.replace(/^[-•]\s*/, '');
        list.append(li);
        return;
      }
      groups.get(current).push(node);
    });
    const layout = document.createDocumentFragment();
    let index = 0;
    groups.forEach((nodes, key) => {
      if (!nodes.length) return;
      const panel = document.createElement('section');
      panel.className = `wp-description-panel wp-description-panel--${key}`;
      const header = document.createElement('div');
      header.className = 'wp-description-heading';
      const number = document.createElement('span');
      number.setAttribute('aria-hidden', 'true');
      number.textContent = String(++index).padStart(2, '0');
      const title = document.createElement('h3');
      title.textContent = labels[key];
      header.append(number, title);
      panel.append(header);
      nodes.forEach(node => {
        if (node.tagName !== 'TABLE') { panel.append(node); return; }
        const firstCell = node.querySelector('thead tr > :first-child');
        if (firstCell && !firstCell.textContent.trim()) firstCell.textContent = labels.measurement;
        const scroller = document.createElement('div');
        scroller.className = 'wp-description-table';
        scroller.tabIndex = 0;
        scroller.setAttribute('role', 'region');
        scroller.setAttribute('aria-label', labels.size);
        scroller.append(node);
        panel.append(scroller);
      });
      layout.append(panel);
    });
    root.replaceChildren(layout);
    root.dataset.formatted = 'true';
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => formatWeariloDescriptions());
} else {
  formatWeariloDescriptions();
}
document.addEventListener('shopify:section:load', event => formatWeariloDescriptions(event.target));


  } catch(e) { console.error(e); }
})();
})();
